import { GroupPresenter } from "@/presenters/group/GroupPresenter";
import { PackageGroupPresenter } from "@/presenters/group/package-group/PackageGroupPresenter";
import { PackagePresenter } from "@/presenters/group/package-group/PackagePresenter";

export class PackageGroupMainPagePresenter {
  constructor(form) {
    this.groups = form.groups.map(group => new GroupPresenter(group));
    this.packageGroup = new PackageGroupPresenter(form.packageGroup);
    this.allPackage = form.allPackage.map(item => new PackagePresenter(item));
  }
}


// WEBPACK FOOTER //
// ./src/presenters/group/package-group/PackageGroupMainPagePresenter.js